import { createIcon } from '@chakra-ui/icons';

export const CircleCheck = createIcon({
  displayName: 'CircleCheck',
  viewBox: '0 0 16 17',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <g clipPath="url(#clip0_454_5055)">
        <path
          d="M5.69951 7.8C5.29951 7.4 4.69951 7.4 4.29951 7.8C3.89951 8.2 3.89951 8.8 4.29951 9.2L6.29951 11.2C6.49951 11.4 6.69951 11.5 6.99951 11.5C7.29951 11.5 7.49951 11.4 7.69951 11.2L14.6995 4.2C15.0995 3.8 15.0995 3.2 14.6995 2.8C14.2995 2.4 13.6995 2.4 13.2995 2.8L6.99951 9.1L5.69951 7.8Z"
          fill="currentColor"
        />
        <path
          d="M6.99951 16.5C10.8995 16.5 13.9995 13.4 13.9995 9.5C13.9995 8.9 13.5995 8.5 12.9995 8.5C12.3995 8.5 11.9995 8.9 11.9995 9.5C11.9995 12.3 9.79951 14.5 6.99951 14.5C4.19951 14.5 1.99951 12.3 1.99951 9.5C1.99951 6.7 4.19951 4.5 6.99951 4.5C7.59951 4.5 8.09951 4.6 8.69951 4.8C9.19951 5 9.79951 4.7 9.99951 4.2C10.1995 3.7 9.89951 3.1 9.39951 2.9C8.59951 2.6 7.79951 2.5 6.99951 2.5C3.09951 2.5 -0.000488281 5.6 -0.000488281 9.5C-0.000488281 13.4 3.09951 16.5 6.99951 16.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_454_5055">
          <rect width="16" height="16" fill="white" transform="translate(-0.000488281 0.5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
